import React, { useState } from "react";
import Cards from "../../../common/Cards";
import Input from "../../../form/Input";
import Switch from "../../../form/Switch";
import Button from "../../../form/Button";
import Form from "../../../form/Form";
import useForm from "../../../../hooks/useForm";
import { useMutation } from "@tanstack/react-query";
import {
  userAddEdit,
  userPasswordChange,
} from "../../../../services/userService";
import { toast } from "react-toastify";
import { generatePassword } from "../../../../helpers";

const validation = {
  password: { required: true, message: "password is required" },
  confirmPassword: {
    required: true,
    message: "Confirm password is required",
  },
};
const PasswordSettings = ({ details, getResponse = () => {}, loading }) => {
  const [checked, setChecked] = useState(false);

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: checked ? null : validation,
  });

  const {
    mutate: onSubmit,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      const { ...rest } = val;
      delete rest?._id;
      return await userPasswordChange(
        details?._id
          ? { userId: details?._id, ...rest }
          : {
              ...val,
            }
      );
    },
    onSuccess: (res) => {
      if (res?.status === 200) {
        toast.success(res?.message);
      } else {
        toast.warning(res?.message);
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { mutate: resetPasswordByMail, isPending: isEmailResetPending } =
    useMutation({
      mutationFn: async (val) => {
        const res = await userPasswordChange({
          userId: details?._id,
          resetLink: "true",
        });
        return res;
      },
      onSuccess: (res) => {
        if (res?.status === 200) {
          toast.success(res?.message);
        } else {
          toast.warning(res?.message);
        }
        return res;
      },
      onError: (error) => {
        console.log(error);
      },
    });

  return (
    <Cards
      title="Password Change Method"
      description="Choose how you'd like to change your password."
    >
      <Form
        className="space-y-4"
        onSubmit={onSubmit}
        handleSubmit={handleSubmit}
        loading={loading}
      >
        <div className="flex items-center gap-2">
          <span className="font-medium text-sm text-primary">
            {!checked ? "Change via Email" : "Change Manually"}
          </span>
          <Switch
            checked={checked}
            disabled={isLoading || loading || isEmailResetPending}
            onChange={(e) => {
              setChecked(e?.target?.checked);
            }}
          />
        </div>
        {!checked && (
          <div>
            <Button
              buttonLabelClasses={"text-xs text-primary"}
              buttonLabel={"Auto generate password"}
              buttonClasses={
                "bg-transparent h-7 mb-2 hover:bg-primary/20 ml-auto"
              }
              buttonFunction={() => {
                const password = generatePassword(18);
                setFieldsValue({ password, confirmPassword: password });
              }}
            />
            <div className="grid grid-cols-2 gap-3">
              <Input
                inputType={"password"}
                label={"Password"}
                inputPlaceholder="Enter password"
                onChange={handleChange}
                inputName={"password"}
                value={values?.password}
                {...formValidate(errors, "password")}
              />
              <Input
                inputType={"password"}
                label={"Confirm Password"}
                inputPlaceholder="Enter confirm password"
                onChange={handleChange}
                inputName={"confirmPassword"}
                value={values?.confirmPassword}
                {...formValidate(errors, "confirmPassword")}
              />
            </div>
          </div>
        )}
        <div className="mt-2 flex justify-end">
          <Button
            {...(checked
              ? {
                  buttonFunction: resetPasswordByMail,
                }
              : { buttonType: "submit" })}
            buttonClasses={"min-w-36"}
            buttonLabel={!checked ? "Save" : "Send Email"}
            {...((isLoading || loading || isEmailResetPending) && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
        </div>
      </Form>
    </Cards>
  );
};

export default PasswordSettings;
